import { TemplateResult, html, CSSResultGroup } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import styles from './carousel-item.styles';

/**
 * @slot default - The component default content
 *
 * @csspart base - The component's base wrapper.
 * @csspart slide - The component's slide container.
 * @csspart part-default - The component's default slot.
 */

export class BlocksCarouselItem extends BlocksElement {static styles: CSSResultGroup = styles;

  /**
   * Caption Text for carousel slides
   */
  @property({ type: String })
  captionText = '';

  /**
   * Aria label attribute, To be used only for accessibility
   * Provides an accessible name for the carousel element
   */
  @property({ type: String })
  arialabel: string | undefined;

  /**
   * Aria role description attribute, To be used only for accessibility
   * To define a localized and human-readable description for a role
   * If the aria-roledescription property is set to slide,
   * we should not set the aria-label property to slide because this would be redundant.
   */
  @property({ type: String })
  ariaroledescription = 'slide';

  render(): TemplateResult<1> {
    return html`<div part="base" class="cat-c-carousel-item-wrapper">
      <div part="slide" role="group" class="cat-c-carousel-item-slide">
        <slot part="part-default"></slot>
      </div>
    </div>`;
  }
}

if (customElements.get('cat-carousel-item') === undefined) {
  customElements.define('cat-carousel-item', BlocksCarouselItem);
}

declare global {
  interface HTMLElementTagNameMap {
    'cat-carousel-item': BlocksCarouselItem;
  }
}
